// extracted by mini-css-extract-plugin
export default {"viewerSection":"PersonalDataPolicy_viewerSection__O2k-P","viewer":"PersonalDataPolicy_viewer__Wy9Ql","page":"PersonalDataPolicy_page__sUO8-"};